var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-default ae-search-bar-button ae-search-bar__filter-button",class:{ 'applied': _vm.filterState.filtersAreApplied },attrs:{"type":"button","title":"Filter"},on:{"click":function($event){return _vm.toggleModal()}}},[_c('i',{staticClass:"fa fa-filter"})])
}
var staticRenderFns = []

export { render, staticRenderFns }